'use client'
import React from 'react';
import { useTheme } from 'next-themes'
import { Toaster as Sonner, ToasterProps } from 'sonner'

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--success-bg': '#15803d',
          '--success-text': '#ffffff',
          '--success-border': '#166534',
          '--info-bg': '#1d4ed8',
          '--info-text': '#ffffff',
          '--info-border': '#1e40af',
          '--warning-bg': '#d97706',
          '--warning-text': '#ffffff',
          '--warning-border': '#b45309',
          '--error-bg': '#b91c1c',
          '--error-text': '#ffffff',
          '--error-border': '#7f1d1d',
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
